/* eslint-disable no-param-reassign */
import { concat } from 'ramda';

import { FETCH_STATUSES } from '../../../utils/fetchStatusUtils';

export default function loadAdditionalResourcesSlice(options) {
  const { pluralResource, repository } = options;

  return {
    initialState: {
      [pluralResource]: {
        loadingStatus: FETCH_STATUSES.idle,
        items: [],
        meta: {},
        error: null,
      },
    },
    reducers: {
      loadAdditionalResourcesStart(state) {
        state[pluralResource].loadingStatus = FETCH_STATUSES.pending;
        state[pluralResource].error = null;
      },
      loadAdditionalResourcesSuccess(state, { payload: { items, meta } }) {
        state[pluralResource].loadingStatus = FETCH_STATUSES.fulfilled;
        state[pluralResource].items = concat(
          state[pluralResource].items,
          items
        );
        state[pluralResource].meta = meta;
      },
      loadAdditionalResourcesFail(state, { payload: { errors } }) {
        state[pluralResource].loadingStatus = FETCH_STATUSES.failed;
        state[pluralResource].error = errors;
      },
      loadAdditionalResourcesReset(state) {
        state[pluralResource].loadingStatus = FETCH_STATUSES.idle;
        state[pluralResource].errors = null;
        state[pluralResource].items = [];
        state[pluralResource].meta = {};
      },
    },

    actionCreators(restDispatch) {
      return {
        loadAdditionalResources: async (params) => {
          try {
            restDispatch('loadAdditionalResourcesStart');
            const result = await repository.load(params);
            const { data } = result;
            const successParams = {
              items: data[pluralResource],
              meta: data.meta,
            };
            restDispatch('loadAdditionalResourcesSuccess', successParams);
          } catch (errors) {
            const { response } = errors;
            const { data } = response;
            restDispatch('loadAdditionalResourcesFail', data);
            throw errors;
          }
        },
        loadAdditionalResetResources: () =>
          restDispatch('loadAdditionalResourcesReset'),
      };
    },
  };
}
